import { WatchQueryFetchPolicy } from '@apollo/client'
import { MutationFetchPolicy } from '@apollo/client/core/watchQueryOptions'

type globalConstantsType_ = {
  networkOnly: WatchQueryFetchPolicy
  networkOnlyMutation: MutationFetchPolicy
  invalidPhoneNumber: string
  phoneNumberShouldNotExceedTen: string
  specialCharactersNotAllowed: string
  apiContentTypejson: string
  previewSettings: { isFluidWidth: boolean; width: number; height: number }
  filterBooleanValue: {
    true: string
    false: string
  }
  scriptType: {
    electric: string
    gas: string
    dual: string
    solar: string
  }
  tpvType: {
    outboundLiveAgent: string
    ivr: string
    smsTpv: string
    liveAgent: string
    notpv: string
  }
}
export const GLOBAL_CONSTANTS: globalConstantsType_ = {
  networkOnly: 'network-only',
  networkOnlyMutation: 'network-only',
  invalidPhoneNumber: 'Invalid Phone number',
  phoneNumberShouldNotExceedTen: "Phone number shouldn't exceed 10 digits",
  specialCharactersNotAllowed: 'Special characters not allowed',
  apiContentTypejson: 'application/json',
  previewSettings: { isFluidWidth: true, width: 500, height: 500 },
  filterBooleanValue: {
    true: 'TRUE',
    false: 'FALSE',
  },
  scriptType: {
    electric: 'Electric',
    gas: 'Gas',
    dual: 'Dual',
    solar: 'Solar',
  },
  tpvType: {
    outboundLiveAgent: 'OUTBOUND LIVE AGENT',
    ivr: 'IVR',
    smsTpv: 'SMS TPV',
    liveAgent: 'LIVE AGENT',
    notpv: 'NO TPV',
  },
}

export const MemberRole = {
  SYSTEM_ADMIN: 'System Admin',
  SALES_ADMIN: 'Sales Admin',
  AGENT: 'Agent',
  QC_USER: 'QC User',

}

export const fetchPolicyKey = 'network-only'

export const ratePlaceHolder = 'Enter E_rate'
export const gRatePlaceHolder = 'Enter G_rate'
export const timeFormat = 'll, hh:mm A'

export const urlPath = {
  tpvRecording: 'tpv-report',
  salesChannel: 'sales-channel-list',
}




export const FONT_FAMILY = [
  // Courier
  { id: 'Courier', value: 'Courier' },
  { id: 'Courier-Bold', value: 'Courier-Bold' },
  { id: 'Courier-Oblique', value: 'Courier-Oblique' },
  { id: 'Courier-BoldOblique', value: 'Courier-BoldOblique' },
  // Helvetica
  { id: 'Helvetica', value: 'Helvetica' },
  { id: 'Helvetica-Bold', value: 'Helvetica-Bold' },
  { id: 'Helvetica-Oblique', value: 'Helvetica-Oblique' },
  { id: 'Helvetica-BoldOblique', value: 'Helvetica-BoldOblique' },
  // Times
  { id: 'Times-Roman', value: 'Times-Roman' },
  { id: 'Times-Bold', value: 'Times-Bold' },
  // Others
  { id: 'Symbol', value: 'Symbol' },
]

export const FONT_SIZE = [
  { id: '8', value: 8 },
  { id: '9', value: 9 },
  { id: '10', value: 10 },
  { id: '11', value: 11 },
  { id: '12', value: 12 },
  { id: '13', value: 13 },
  { id: '14', value: 14 },
  { id: '15', value: 15 },
  { id: '16', value: 16 },
]

export const POSITION_ID: Record<string, number> = {
  TC: 0,
  DSC: 1,
  OTHER: 2,
};